/* eslint-disable prefer-destructuring */

import apiHttpRequest from "services/api-http-request";
// import airconditionerPowerCheck from "services/airconditioner-http-request";
import chungohhhh1HttpRequest from "services/chungohhhh1-http-request";
import axios from 'axios';
import { isSchema } from "yup";

const getHouseActuatorDetail = async (actuatorId) => {
  const params = {};
  
  let detail = {};

  try {
    // if(actuatorId === 'airconditioner_1' || actuatorId === 'airconditioner_2'){
    //   detail = await apiHttpRequest.get(`/HOUSE/ACTUATOR/${actuatorId}/STATUS`);  
    // }else{
      detail = await apiHttpRequest.get(`/house/actuator/${actuatorId}`, params);
    // }
      
      const type = detail[0].sensor_type;
      if(type === 'FAN_1'){
        detail[0].sensor_type= 'FAN_3';
      }else if(type === 'FAN_2'){
        detail[0].sensor_type= 'FAN_1';
      }else if(type === 'FAN_3'){
        detail[0].sensor_type= 'FAN_4';
      }else if(type === 'FAN_4'){
        detail[0].sensor_type= 'FAN_2';
      }
  } catch (e) {
    console.error(e);
  }

  return detail
}

const getHouseAcTemp = async (acId) => {
  const params = {};

  let detail = {};

  let number = null;
  // if(acId==='fan_1'){
  //   acId = 'fan_3'
  // }

  if (acId && acId.indexOf('_') > 0) {
    number = acId.split('_')[1];
  }

  if (number) {
    try {
      detail = await apiHttpRequest.get(`/house/actuator/airconditioner_temp_${number}`, params);
    } catch (e) {
      console.error(e);
    }
  }

  return detail
}

const getAirconditionData = async (acId) => {
  
  const params = {};
  const responses = [];
  const aircon = [];
  const times = [];
  const temps = [];
  const power = [];
  
  let number = null;

  if (acId && acId.indexOf('_') > 0) {
    number = acId.split('_')[1];
  }
  try {
    if (number) {
      
      const air1 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_STATION_1`, params);
      aircon.push(air1);
      const air2 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_STATION_2`, params);
      aircon.push(air2);
      const air3 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_STATION_3`, params);
      aircon.push(air3);
      const air4 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_STATION_4`, params);
      aircon.push(air4);
      const air5 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_STATION_5`, params);
      aircon.push(air5);

      const time1 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TIME_1`, params);
      times.push(time1);
      const time2 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TIME_2`, params);
      times.push(time2);
      const time3 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TIME_3`, params);
      times.push(time3);
      const time4 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TIME_4`, params);
      times.push(time4);
      const time5 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TIME_5`, params);
      times.push(time5);

      const temp1 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TEMP_1`, params);
      temps.push(temp1);
      const temp2 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TEMP_2`, params);
      temps.push(temp2);
      const temp3 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TEMP_3`, params);
      temps.push(temp3);
      const temp4 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TEMP_4`, params);
      temps.push(temp4);
      const temp5 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AC${number}_TEMP_5`, params);
      temps.push(temp5);

      const power1 = await apiHttpRequest.get(`/house/actuator/${acId}`, params);
      // const power1 = await apiHttpRequest.get(`/HOUSE/ACTUATOR/AIRCONDITIONER_${number}/STATUS`, params);
      power.push(power1);
    }
    responses.push(aircon);
    responses.push(times);
    responses.push(temps);
    responses.push(power);
  } catch (e) {
    console.error("에어컨 데이터 요청 실패:", e);
  }
  return responses;
};

const getFanData = async (acId) => {
  const params = {};
  let fan = [];

  
  let number = null;

  if (acId && acId.indexOf('_') > 0) {
    number = acId.split('_')[1];
  }
  try {
    if (number) {
       fan = await apiHttpRequest.get(`/HOUSE/ACTUATOR/FAN_${number}`, params);
      
    }

  } catch (e) {
    console.error("에어컨 데이터 요청 실패:", e);
  }
  return fan;
};
const getWindowData = async (acId) => {
  
  const params = {};
  let fan = [];

  
  let number = null;

  if (acId) {
    if (acId === 'double_side_window_1') {
      number = 1;
    } else if (acId === 'double_side_window_2') {
      number = 2;
    }
  }
  try {
    if (number) {
       fan = await apiHttpRequest.get(`/HOUSE/ACTUATOR/DOUBLE_SIDE_WINDOW_${number}`, params);
    }

  } catch (e) {
    console.error("에어컨 데이터 요청 실패:", e);
  }
  return fan;
};



const updateHouseFanSensorValue = async (actuatorId, sensorValue) => {

  let device = null;
  let reqValue = null;
  let response = {};

  if (actuatorId) {
    if (actuatorId === 'fan_1') {
      device = 1;
      reqValue = 2;
    } else if (actuatorId === 'fan_2') {
      device = 2;
      reqValue = 2;
    } else if (actuatorId === 'fan_3') {
      device = 1;
      reqValue = 1;
    } else if (actuatorId === 'fan_4') {
      device = 2;
      reqValue = 1;
    }
  }

  if (device && reqValue) {
    try {
      response = await chungohhhh1HttpRequest.get(`/fan/active/device/${device}/req_value/${reqValue}/value/${sensorValue}`);
    } catch (e) {
      console.error(e);
    }
  }

  return response;
}

const updateHouseAcPower = async (actuatorId, powerValue) => {
  let device = null;
  let response = {};

  if (actuatorId) {
    if (actuatorId === 'airconditioner_1') {
      device = 1;
    } else if (actuatorId === 'airconditioner_2') {
      device = 2;
    }
  }

  if (device) {
    try {
      response = await chungohhhh1HttpRequest.get(`/airconditioner/manual/device/${device}/state/power/value/${powerValue}`);
    } catch (e) {
      console.error(e);
    }
  }

  return response;
}

const updateHouseAcTemp = async (actuatorId, acPowerValue, sections) => {

  let device = null;
  
  const strPower = 'power';
  let isSuccess = true;

  const failItem = [];

  if (actuatorId) {
    if (actuatorId === 'airconditioner_1') {
      device = 1;
    } else if (actuatorId === 'airconditioner_2') {
      device = 2;
    }
  }

  // 에어컨 전원 api
  try {
    const response = await chungohhhh1HttpRequest.get(`/airconditioner/manual/device/${device}/state/${strPower}/value/${acPowerValue}`);
    if(response.result === 'fail'){
      isSuccess = false;
      failItem.push('전원')
    }
    
    /* eslint-disable no-await-in-loop */
    for (let i = 0; i < sections.length; i++) {
      
      const data = sections[i];
      const used = data.isUsed;
      const gugan = data.section.split(' ')[1];
      

      if (used === 1) {
        
        const time = data.startTime.split(':')[0] + data.startTime.split(':')[1];
        
        const strtemp = data.temperature.toString();
        let temp='';
        let rtemp = '';
        if(strtemp.length <= 2){
          rtemp = strtemp+'0';
        }else{
          temp = data.temperature.split('.');
          rtemp = temp[0] + temp[1];
        }

          // if (!data.temperature.includes('.')) {
          //   // 소수점이 없는 경우 뒤에 '.0'을 붙임
          //   temp = data.temperature + '0';
          // } else if (data.temperature.split('.')[1].length === 1) {
          //   // 소수점 뒤 숫자가 한자리인 경우 뒤에 '0'을 붙임
          //   temp = data.temperature + '0';
          // } else {
          //   // 기존 로직 처리
          //   temp = data.temperature.split('.')[0] + data.temperature.split('.')[1];
          // }
          // const temp = data.temperature.split('.')[0] + data.temperature.split('.')[1];

        const guganresponse = await chungohhhh1HttpRequest.get(`/airconditioner/section/control/device/${device}/state/${gugan}/value/${used}`);
        
        
        if(guganresponse.result === 'fail'){
          isSuccess = false;
          failItem.push(gugan+' 구간 구간설정에러')
        }
        const timeresponse = await chungohhhh1HttpRequest.get(`/airconditioner/section/time/device/${device}/state/${gugan}/value/${time}`);
        
        if(timeresponse.result === 'fail'){
          isSuccess = false;
          failItem.push(gugan+' 구간 시간설정에러')
        }

        const tempresponse = await chungohhhh1HttpRequest.get(`/airconditioner/section/temp/device/${device}/state/${gugan}/value/${rtemp}`);
        
        if(tempresponse.result === 'fail'){
          isSuccess = false;
          failItem.push(gugan+' 구간 온도설정에러')
        }

        // promises.push(chungohhhh1HttpRequest.get(`/airconditioner/section/control/device/${device}/state/${gugan}/value/${used}`));
        // promises.push(chungohhhh1HttpRequest.get(`/airconditioner/section/time/device/${device}/state/${gugan}/value/${time}`));
        // promises.push(chungohhhh1HttpRequest.get(`/airconditioner/section/temp/device/${device}/state/${gugan}/value/${temp}`));
      } else {
        
        const elseresponse = await chungohhhh1HttpRequest.get(`/airconditioner/section/control/device/${device}/state/${gugan}/value/${used}`);
        if(elseresponse.result === 'fail'){
          isSuccess = false;
          failItem.push(gugan+' 구간 사용안함설정에러')
        }
      }
    }

    // const results = await Promise.all(promises);

    // // 결과 확인 및 처리
    // for (let i = 0; i < results.length; i++) {
    //   const result = results[i];

    //   if (result.state === 'fail') {
    //     isSuccess = false;
    //   }
    // }

  } catch (e) {
    console.error(e);
    isSuccess = false;
  }

  if (isSuccess) {
    return { state: 'success' };
  } else {
    return { state: 'fail', failItem:failItem, error_message: 'Some operations failed.' };
  }
};


const updateHouseWindowPower = async (actuatorId, powerValue) => {
  let device = null;
  let response = {};

  if (actuatorId) {
    if (actuatorId === 'double_side_window_1') {
      device = 1;
    } else if (actuatorId === 'double_side_window_2') {
      device = 2;
    }
  }

  if (device) {
    try {
      response = await chungohhhh1HttpRequest.get(`/doublesidewindow/manual/device/${device}/state/power/value/${powerValue}`);
    } catch (e) {
      console.error(e);
    }
  }

  return response;
}

const updateHouseWindowTemp = async (actuatorId, openCloseValue, tempValue) => {
  let device = null;
  let response = {};

  if (actuatorId) {
    if (actuatorId === 'double_side_window_1') {
      device = 1;
    } else if (actuatorId === 'double_side_window_2') {
      device = 2;
    }
  }

  let temp = '';
          if (typeof tempValue !== 'string') {
            tempValue = tempValue?.toString() || '';
          }
          if (!tempValue.includes('.')) {
            // 소수점이 없는 경우 뒤에 '.0'을 붙임
            temp = tempValue + '0';
          } else if (tempValue.split('.')[1].length === 1) {
            // 소수점 뒤 숫자가 한자리인 경우 뒤에 '0'을 붙임
            temp = tempValue + '0';
          } else {
            // 기존 로직 처리
            temp = tempValue.split('.')[0] + tempValue.split('.')[1];
          }
          // const temp = data.temperature.split('.')[0] + data.temperature.split('.')[1];
  
  // 여기

  const intTemp = parseInt(temp, 10);

  if (device) {
    try {
      
      response = await chungohhhh1HttpRequest.get(`/doublesidewindow/auto/control/device/${device}/state/temp/kind/${openCloseValue}/value/${intTemp}`);
      
    } catch (e) {
      console.error(e);
    }
  }

  return response;
}

const updateHouseWindowMode = async (actuatorId) => {
  let device = null;
  let response = {};

  if (actuatorId) {
    if (actuatorId === 'double_side_window_1') {
      device = 1;
    } else if (actuatorId === 'double_side_window_2') {
      device = 2;
    }
  }

  if (device) {
    try {
      
      response = await chungohhhh1HttpRequest.get(`/doublesidewindow/auto/device/${device}/state/temp`);
      
    } catch (e) {
      console.error(e);
    }
  }

  return response;
}

const getWindowControllTemp = async (windowId) => {

  const params = {};
  
  const response = [];
  let openTempResponse = {};
  let closeTempResponse = {};
  let id=0;

  if (windowId && windowId.indexOf('_') > 0) {
    id = windowId.split('_')[3];
  }

  
  const openId = 'DSW_OPEN_TEMP_'+id;
  const closeId = 'DSW_CLOSE_TEMP_'+id;

  try {
    // if(actuatorId === 'airconditioner_1' || actuatorId === 'airconditioner_2'){
    //   detail = await apiHttpRequest.get(`/HOUSE/ACTUATOR/${actuatorId}/STATUS`);  
    // }else{
      openTempResponse = await apiHttpRequest.get(`/house/actuator/${openId}`, params);
      closeTempResponse = await apiHttpRequest.get(`/house/actuator/${closeId}`, params);
    // }
    response.push(openTempResponse)
    response.push(closeTempResponse)
    

    
  } catch (e) {
    console.error(e);
  }

  return response
}

const getHouseActuatorFanDetail = async (fanId) => {
  const params = {};
  
  let detail = {};

  if(fanId === 'fan_1'){
    fanId = 'fan_2'
  }else if(fanId === 'fan_2'){
    fanId = 'fan_4'
  }else if(fanId === 'fan_3'){
    fanId = 'fan_1'
  }else if(fanId === 'fan_4'){
    fanId = 'fan_3'
  }

  // fan 제어시 동작하는것의 결과에 따라 조회시 요청하는 fan의 아이디를 수정하는 로직을 추가하면됌

  try {
    // if(actuatorId === 'airconditioner_1' || actuatorId === 'airconditioner_2'){
    //   detail = await apiHttpRequest.get(`/HOUSE/ACTUATOR/${actuatorId}/STATUS`);  
    // }else{
      detail = await apiHttpRequest.get(`/house/actuator/${fanId}`, params);
    // }
    
  } catch (e) {
    console.error(e);
  }

  return detail
}

export default {
  getHouseActuatorDetail,
  getAirconditionData,
  getFanData,
  getWindowData,
  updateHouseFanSensorValue,
  getHouseAcTemp,
  updateHouseAcPower,
  updateHouseAcTemp,
  updateHouseWindowPower,
  updateHouseWindowTemp,
  updateHouseWindowMode,
  getWindowControllTemp,
  getHouseActuatorFanDetail
}